export const colorsTable = {}

export function trackSelection (shape) {
    const r = Math.round(Math.random() * 255);
    const g = Math.round(Math.random() * 255);
    const b = Math.round(Math.random() * 255);
    let key = `rgb(${r},${g},${b})`;
    shape.colorKey = key;
    if (!(key in colorsTable)) {
        colorsTable[key] = shape
    }
    return shape;
}

export function interpolate (a = { x: 0, y: 0 }, b = { x: 0, y: 0 }, frac) {
    var nx = a.x + (b.x - a.x) * frac;
    var ny = a.y + (b.y - a.y) * frac;
    return { x: nx, y: ny };
}

export function formatDate (date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

// https://css-tricks.com/converting-color-spaces-in-javascript/
export function hexToRGB (h) {
    let r = 0, g = 0, b = 0;

    // 3 digits
    if (h.length == 4) {
        r = "0x" + h[1] + h[1];
        g = "0x" + h[2] + h[2];
        b = "0x" + h[3] + h[3];

        // 6 digits
    } else if (h.length == 7) {
        r = "0x" + h[1] + h[2];
        g = "0x" + h[3] + h[4];
        b = "0x" + h[5] + h[6];
    }
    return `rgba(${+r},${+g},${+b},.3)`;
}


export const fastCNCURL='https://fastcnc-react-master.vercel.app'
export const baseURL='https://flusk-backend.onrender.com'

// Download utility function
export const downloadFile = async (filename) => {
  try {
    const response = await fetch(`${baseURL}/api/download/${filename}`);
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }
    
    // Create a blob from the response
    const blob = await response.blob();
    
    // Create a download link
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename;
    
    // Trigger download
    document.body.appendChild(a);
    a.click();
    
    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    
    return true;
  } catch (error) {
    console.error('Download failed:', error);
    alert(`Download failed: ${error.message}`);
    return false;
  }
};

// Alternative direct download function (if S3 is configured for public access)
export const downloadFileDirect = (filename) => {
  const s3Url = `https://fastcnc.s3.eu-central-1.amazonaws.com/uploads/calc/${filename}`;
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = s3Url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
